import { useState, useEffect } from 'react';
import { client } from '../lib/sanity';

export const useHeroSection = () => {
    const [heroSection, setHeroSection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "heroSection"][0]`;
                const data = await client.fetch(query);
                setHeroSection(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return { heroSection, loading, error };
};

export const useAboutSection = () => {
    const [aboutSection, setAboutSection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "aboutSection"][0]`;
                const data = await client.fetch(query);
                setAboutSection(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return { aboutSection, loading, error };
};

export const useFounderSection = () => {
    const [founderSection, setFounderSection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "founderSection"][0]`;
                const data = await client.fetch(query);
                setFounderSection(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return { founderSection, loading, error };
};

export const useServicesSection = () => {
    const [servicesSection, setServicesSection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "servicesSectionId"][0] {
                    title,
                    services[] {
                        title,
                        description,
                        "imageUrl": image.asset->url
                    }
                }`;
                const data = await client.fetch(query);
                setServicesSection(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return { servicesSection, loading, error };
};

export const useTestimonialSection = () => {
    const [testimonialSection, setTestimonialSection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "testimonialSection"][0] {
                    testimonial,
                    author
                }`;
                const data = await client.fetch(query);
                setTestimonialSection(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return { testimonialSection, loading, error };
};

export const useWhyChooseUsSection = () => {
    const [whyChooseUsSection, setWhyChooseUsSection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "whyChooseUsSectionId"][0] {
                    title,
                    points[] {
                        title,
                        description
                    },
                    image {
                        asset->{url}
                    }
                }`;
                const data = await client.fetch(query);
                setWhyChooseUsSection(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return { whyChooseUsSection, loading, error };
}; 